import { UUID } from "../uuid";

export class BetfairMessage {
  public betfairStreamMessageId: UUID;
  public eventId: string;
  public createdAt: number;
  public payload: string;

  public static deserialize(msg: any): BetfairMessage {
    return {
      betfairStreamMessageId:
        msg.betfairStreamMessageId &&
        UUID.fromString(msg.betfairStreamMessageId),
      eventId: msg.eventId,
      createdAt: msg.createdAt,
      payload: msg.payload,
    };
  }
}

export enum MarketType {
  MATCH_ODDS = "MATCH_ODDS",

  INNINGS_1_RUNS_LINE = "INNINGS_1_RUNS_LINE",
  INNINGS_2_RUNS_LINE = "INNINGS_2_RUNS_LINE",

  INNINGS_1_20_OVER_LINE = "INNINGS_1_20_OVER_LINE",
  INNINGS_2_20_OVER_LINE = "INNINGS_2_20_OVER_LINE",

  INNINGS_1_6_OVER_LINE = "INNINGS_1_6_OVER_LINE",
  INNINGS_2_6_OVER_LINE = "INNINGS_2_6_OVER_LINE",

  INNINGS_1_100_BALL_LINE = "INNINGS_1_100_BALL_LINE",
  INNINGS_2_100_BALL_LINE = "INNINGS_2_100_BALL_LINE",

  INNINGS_1_25_BALL_LINE = "INNINGS_1_25_BALL_LINE",
  INNINGS_2_25_BALL_LINE = "INNINGS_2_25_BALL_LINE",

  INNINGS_1_50_OVER_LINE = "INNINGS_1_50_OVER_LINE",
  INNINGS_2_50_OVER_LINE = "INNINGS_2_50_OVER_LINE",

  INNINGS_1_10_OVER_LINE = "INNINGS_1_10_OVER_LINE",
  INNINGS_2_10_OVER_LINE = "INNINGS_2_10_OVER_LINE",

  COMPLETED_MATCH = "COMPLETED_MATCH",
  TIED_MATCH = "TIED_MATCH",

  MATCH_ODDS_INCLUDING_TIE = "MATCH_ODDS_INCLUDING_TIE",

  INNINGS_1_RUNS = "INNINGS_1_RUNS",
  INNINGS_2_RUNS = "INNINGS_2_RUNS",

  INNINGS_1_15_OVER_LINE = "INNINGS_1_15_OVER_LINE",
  INNINGS_2_15_OVER_LINE = "INNINGS_2_15_OVER_LINE",

  MATCH_ODDS_DRAW_NO_BET = "MATCH_ODDS_DRAW_NO_BET",
  TEST_MATCH_END = "TEST_MATCH_END",
  TO_WIN_THE_TOSS = "TO_WIN_THE_TOSS",
  SUPER_OVER = "SUPER_OVER",
  TOURNAMENT_WINNER = "TOURNAMENT_WINNER",
  INNINGS_1_10_OVER_TOTAL = "INNINGS_1_10_OVER_TOTAL",
  INNINGS_2_10_OVER_TOTAL = "INNINGS_2_10_OVER_TOTAL",
  INNINGS_1_25_BALL_TOTAL = "INNINGS_1_25_BALL_TOTAL",
  INNINGS_2_25_BALL_TOTAL = "INNINGS_2_25_BALL_TOTAL",
  INNINGS_1_50_BALL_LINE = "INNINGS_1_50_BALL_LINE",
  INNINGS_2_50_BALL_LINE = "INNINGS_2_50_BALL_LINE",
  INNINGS_1_75_BALL_LINE = "INNINGS_1_75_BALL_LINE",
  INNINGS_2_75_BALL_LINE = "INNINGS_2_75_BALL_LINE",
  INNINGS_1_TEAM_A_RUNS_LINE = "INNINGS_1_TEAM_A_RUNS_LINE",
  INNINGS_2_TEAM_A_RUNS_LINE = "INNINGS_2_TEAM_A_RUNS_LINE",
  INNINGS_1_TEAM_B_RUNS_LINE = "INNINGS_1_TEAM_B_RUNS_LINE",
  INNINGS_2_TEAM_B_RUNS_LINE = "INNINGS_2_TEAM_B_RUNS_LINE",
  INNINGS_1_TEAM_A_RUNS = "INNINGS_1_TEAM_A_RUNS",
  INNINGS_2_TEAM_A_RUNS = "INNINGS_2_TEAM_A_RUNS",
  INNINGS_1_TEAM_B_RUNS = "INNINGS_1_TEAM_B_RUNS",
  INNINGS_2_TEAM_B_RUNS = "INNINGS_2_TEAM_B_RUNS",
  PLAYER_RUNS_TEAM_A = "PLAYER_RUNS_TEAM_A",
  PLAYER_RUNS_TEAM_B = "PLAYER_RUNS_TEAM_B",
  INNINGS_1_2_OVER_LINE = "INNINGS_1_2_OVER_LINE",
  INNINGS_2_2_OVER_LINE = "INNINGS_2_2_OVER_LINE",
  INNINGS_1_3_OVER_LINE = "INNINGS_1_3_OVER_LINE",
  INNINGS_2_3_OVER_LINE = "INNINGS_2_3_OVER_LINE",
  INNINGS_1_4_OVER_LINE = "INNINGS_1_4_OVER_LINE",
  INNINGS_2_4_OVER_LINE = "INNINGS_2_4_OVER_LINE",
  INNINGS_1_8_OVER_LINE = "INNINGS_1_8_OVER_LINE",
  INNINGS_2_8_OVER_LINE = "INNINGS_2_8_OVER_LINE",
  INNINGS_1_12_OVER_LINE = "INNINGS_1_12_OVER_LINE",
  INNINGS_2_12_OVER_LINE = "INNINGS_2_12_OVER_LINE",
  INNINGS_1_18_OVER_LINE = "INNINGS_1_18_OVER_LINE",
  INNINGS_2_18_OVER_LINE = "INNINGS_2_18_OVER_LINE",
  INNINGS_1_25_OVER_LINE = "INNINGS_1_25_OVER_LINE",
  INNINGS_2_25_OVER_LINE = "INNINGS_2_25_OVER_LINE",
  INNINGS_1_30_OVER_LINE = "INNINGS_1_30_OVER_LINE",
  INNINGS_2_30_OVER_LINE = "INNINGS_2_30_OVER_LINE",
  INNINGS_1_35_OVER_LINE = "INNINGS_1_35_OVER_LINE",
  INNINGS_2_35_OVER_LINE = "INNINGS_2_35_OVER_LINE",
  INNINGS_1_40_OVER_LINE = "INNINGS_1_40_OVER_LINE",
  INNINGS_2_40_OVER_LINE = "INNINGS_2_40_OVER_LINE",
  INNINGS_1_45_OVER_LINE = "INNINGS_1_45_OVER_LINE",
  INNINGS_2_45_OVER_LINE = "INNINGS_2_45_OVER_LINE",
  TOP_BATSMAN = "TOP_BATSMAN",
  INNINGS_1_TEAM_A_TOP_BATTER = "INNINGS_1_TEAM_A_TOP_BATTER",
  INNINGS_1_TEAM_B_TOP_BATTER = "INNINGS_1_TEAM_B_TOP_BATTER",
  INNINGS_2_TEAM_A_TOP_BATTER = "INNINGS_2_TEAM_A_TOP_BATTER",
  INNINGS_2_TEAM_B_TOP_BATTER = "INNINGS_2_TEAM_B_TOP_BATTER",
  INNINGS_1_TEAM_A_5_OVER_LINE = "INNINGS_1_TEAM_A_5_OVER_LINE",
  INNINGS_1_TEAM_A_10_OVER_LINE = "INNINGS_1_TEAM_A_10_OVER_LINE",
  INNINGS_1_TEAM_A_15_OVER_LINE = "INNINGS_1_TEAM_A_15_OVER_LINE",
  INNINGS_1_TEAM_A_20_OVER_LINE = "INNINGS_1_TEAM_A_20_OVER_LINE",
  INNINGS_1_TEAM_A_25_OVER_LINE = "INNINGS_1_TEAM_A_25_OVER_LINE",
  INNINGS_1_TEAM_A_30_OVER_LINE = "INNINGS_1_TEAM_A_30_OVER_LINE",
  INNINGS_1_TEAM_A_35_OVER_LINE = "INNINGS_1_TEAM_A_35_OVER_LINE",
  INNINGS_1_TEAM_A_40_OVER_LINE = "INNINGS_1_TEAM_A_40_OVER_LINE",
  INNINGS_1_TEAM_A_45_OVER_LINE = "INNINGS_1_TEAM_A_45_OVER_LINE",
  INNINGS_1_TEAM_A_50_OVER_LINE = "INNINGS_1_TEAM_A_50_OVER_LINE",
  INNINGS_2_TEAM_A_5_OVER_LINE = "INNINGS_2_TEAM_A_5_OVER_LINE",
  INNINGS_2_TEAM_A_10_OVER_LINE = "INNINGS_2_TEAM_A_10_OVER_LINE",
  INNINGS_2_TEAM_A_15_OVER_LINE = "INNINGS_2_TEAM_A_15_OVER_LINE",
  INNINGS_2_TEAM_A_20_OVER_LINE = "INNINGS_2_TEAM_A_20_OVER_LINE",
  INNINGS_2_TEAM_A_25_OVER_LINE = "INNINGS_2_TEAM_A_25_OVER_LINE",
  INNINGS_2_TEAM_A_30_OVER_LINE = "INNINGS_2_TEAM_A_30_OVER_LINE",
  INNINGS_2_TEAM_A_35_OVER_LINE = "INNINGS_2_TEAM_A_35_OVER_LINE",
  INNINGS_2_TEAM_A_40_OVER_LINE = "INNINGS_2_TEAM_A_40_OVER_LINE",
  INNINGS_2_TEAM_A_45_OVER_LINE = "INNINGS_2_TEAM_A_45_OVER_LINE",
  INNINGS_2_TEAM_A_50_OVER_LINE = "INNINGS_2_TEAM_A_50_OVER_LINE",
  INNINGS_1_TEAM_B_5_OVER_LINE = "INNINGS_1_TEAM_B_5_OVER_LINE",
  INNINGS_1_TEAM_B_10_OVER_LINE = "INNINGS_1_TEAM_B_10_OVER_LINE",
  INNINGS_1_TEAM_B_15_OVER_LINE = "INNINGS_1_TEAM_B_15_OVER_LINE",
  INNINGS_1_TEAM_B_20_OVER_LINE = "INNINGS_1_TEAM_B_20_OVER_LINE",
  INNINGS_1_TEAM_B_25_OVER_LINE = "INNINGS_1_TEAM_B_25_OVER_LINE",
  INNINGS_1_TEAM_B_30_OVER_LINE = "INNINGS_1_TEAM_B_30_OVER_LINE",
  INNINGS_1_TEAM_B_35_OVER_LINE = "INNINGS_1_TEAM_B_35_OVER_LINE",
  INNINGS_1_TEAM_B_40_OVER_LINE = "INNINGS_1_TEAM_B_40_OVER_LINE",
  INNINGS_1_TEAM_B_45_OVER_LINE = "INNINGS_1_TEAM_B_45_OVER_LINE",
  INNINGS_1_TEAM_B_50_OVER_LINE = "INNINGS_1_TEAM_B_50_OVER_LINE",
  INNINGS_2_TEAM_B_5_OVER_LINE = "INNINGS_2_TEAM_B_5_OVER_LINE",
  INNINGS_2_TEAM_B_10_OVER_LINE = "INNINGS_2_TEAM_B_10_OVER_LINE",
  INNINGS_2_TEAM_B_15_OVER_LINE = "INNINGS_2_TEAM_B_15_OVER_LINE",
  INNINGS_2_TEAM_B_20_OVER_LINE = "INNINGS_2_TEAM_B_20_OVER_LINE",
  INNINGS_2_TEAM_B_25_OVER_LINE = "INNINGS_2_TEAM_B_25_OVER_LINE",
  INNINGS_2_TEAM_B_30_OVER_LINE = "INNINGS_2_TEAM_B_30_OVER_LINE",
  INNINGS_2_TEAM_B_35_OVER_LINE = "INNINGS_2_TEAM_B_35_OVER_LINE",
  INNINGS_2_TEAM_B_40_OVER_LINE = "INNINGS_2_TEAM_B_40_OVER_LINE",
  INNINGS_2_TEAM_B_45_OVER_LINE = "INNINGS_2_TEAM_B_45_OVER_LINE",
  INNINGS_2_TEAM_B_50_OVER_LINE = "INNINGS_2_TEAM_B_50_OVER_LINE",
}

export const marketTypeReadableNames: Record<MarketType, string> = {
  MATCH_ODDS: "Match Odds",

  INNINGS_1_RUNS_LINE: "1st Innings Runs Line",
  INNINGS_2_RUNS_LINE: "2nd Innings Runs Line",

  INNINGS_1_20_OVER_LINE: "1st Innings 20 Overs Line",
  INNINGS_2_20_OVER_LINE: "2nd Innings 20 Overs Line",

  INNINGS_1_6_OVER_LINE: "1st Innings 6 Overs Line",
  INNINGS_2_6_OVER_LINE: "2nd Innings 6 Overs Line",

  INNINGS_1_100_BALL_LINE: "Hundred 1st Innings 100 Balls",
  INNINGS_2_100_BALL_LINE: "Hundred 2nd Innings 100 Balls",

  INNINGS_1_25_BALL_LINE: "Hundred 1st Innings 25 Balls",
  INNINGS_2_25_BALL_LINE: "Hundred 2nd Innings 25 Balls",

  INNINGS_1_50_OVER_LINE: "1st Innings 50 Overs Line",
  INNINGS_2_50_OVER_LINE: "2nd Innings 50 Overs Line",

  INNINGS_1_10_OVER_LINE: "1st Innings 10 Overs Line",
  INNINGS_2_10_OVER_LINE: "2nd Innings 10 Overs Line",

  COMPLETED_MATCH: "Completed Match",
  TIED_MATCH: "Tied Match",

  MATCH_ODDS_INCLUDING_TIE: "Match Odds Including Tie",

  INNINGS_1_RUNS: "1st Innings Runs",
  INNINGS_2_RUNS: "2nd Innings Runs",

  INNINGS_1_15_OVER_LINE: "1st Innings 15 Overs Line",
  INNINGS_2_15_OVER_LINE: "2nd Innings 15 Overs Line",

  MATCH_ODDS_DRAW_NO_BET: "Match Odds Draw No Bet",
  TEST_MATCH_END: "Test Match End",
  TO_WIN_THE_TOSS: "To Win The Toss",
  SUPER_OVER: "Super Over",
  TOURNAMENT_WINNER: "Tournament Winner",
  INNINGS_1_10_OVER_TOTAL: "Innings 1 10 Over Total",
  INNINGS_2_10_OVER_TOTAL: "Innings 2 10 Over Total",
  INNINGS_1_25_BALL_TOTAL: "Innings 1 25 Ball Total",
  INNINGS_2_25_BALL_TOTAL: "Innings 2 25 Ball Total",
  INNINGS_1_50_BALL_LINE: "Innings 1 50 Ball Line",
  INNINGS_2_50_BALL_LINE: "Innings 2 50 Ball Line",
  INNINGS_1_75_BALL_LINE: "Innings 1 75 Ball Line",
  INNINGS_2_75_BALL_LINE: "Innings 2 75 Ball Line",
  INNINGS_1_TEAM_A_RUNS_LINE: "Innings 1 Team A Runs Line",
  INNINGS_2_TEAM_A_RUNS_LINE: "Innings 2 Team A Runs Line",
  INNINGS_1_TEAM_B_RUNS_LINE: "Innings 1 Team B Runs Line",
  INNINGS_2_TEAM_B_RUNS_LINE: "Innings 2 Team B Runs Line",
  INNINGS_1_TEAM_A_RUNS: "Innings 1 Team A Runs",
  INNINGS_2_TEAM_A_RUNS: "Innings 2 Team A Runs",
  INNINGS_1_TEAM_B_RUNS: "Innings 1 Team B Runs",
  INNINGS_2_TEAM_B_RUNS: "Innings 2 Team B Runs",
  PLAYER_RUNS_TEAM_A: "Player Runs Team A",
  PLAYER_RUNS_TEAM_B: "Player Runs Team B",
  INNINGS_1_2_OVER_LINE: "Innings 1 2 Over Line",
  INNINGS_2_2_OVER_LINE: "Innings 2 2 Over Line",
  INNINGS_1_3_OVER_LINE: "Innings 1 3 Over Line",
  INNINGS_2_3_OVER_LINE: "Innings 2 3 Over Line",
  INNINGS_1_4_OVER_LINE: "Innings 1 4 Over Line",
  INNINGS_2_4_OVER_LINE: "Innings 2 4 Over Line",
  INNINGS_1_8_OVER_LINE: "Innings 1 8 Over Line",
  INNINGS_2_8_OVER_LINE: "Innings 2 8 Over Line",
  INNINGS_1_12_OVER_LINE: "Innings 1 12 Over Line",
  INNINGS_2_12_OVER_LINE: "Innings 2 12 Over Line",
  INNINGS_1_18_OVER_LINE: "Innings 1 18 Over Line",
  INNINGS_2_18_OVER_LINE: "Innings 2 18 Over Line",
  INNINGS_1_25_OVER_LINE: "Innings 1 25 Over Line",
  INNINGS_2_25_OVER_LINE: "Innings 2 25 Over Line",
  INNINGS_1_30_OVER_LINE: "Innings 1 30 Over Line",
  INNINGS_2_30_OVER_LINE: "Innings 2 30 Over Line",
  INNINGS_1_35_OVER_LINE: "Innings 1 35 Over Line",
  INNINGS_2_35_OVER_LINE: "Innings 2 35 Over Line",
  INNINGS_1_40_OVER_LINE: "Innings 1 40 Over Line",
  INNINGS_2_40_OVER_LINE: "Innings 2 40 Over Line",
  INNINGS_1_45_OVER_LINE: "Innings 1 45 Over Line",
  INNINGS_2_45_OVER_LINE: "Innings 2 45 Over Line",
  TOP_BATSMAN: "Top Batsman",
  INNINGS_1_TEAM_A_TOP_BATTER: "Innings 1 Team A Top Batter",
  INNINGS_1_TEAM_B_TOP_BATTER: "Innings 1 Team B Top Batter",
  INNINGS_2_TEAM_A_TOP_BATTER: "Innings 2 Team A Top Batter",
  INNINGS_2_TEAM_B_TOP_BATTER: "Innings 2 Team B Top Batter",
  INNINGS_1_TEAM_A_5_OVER_LINE: "Innings 1 Team A 5 Over Line",
  INNINGS_1_TEAM_A_10_OVER_LINE: "Innings 1 Team A 10 Over Line",
  INNINGS_1_TEAM_A_15_OVER_LINE: "Innings 1 Team A 15 Over Line",
  INNINGS_1_TEAM_A_20_OVER_LINE: "Innings 1 Team A 20 Over Line",
  INNINGS_1_TEAM_A_25_OVER_LINE: "Innings 1 Team A 25 Over Line",
  INNINGS_1_TEAM_A_30_OVER_LINE: "Innings 1 Team A 30 Over Line",
  INNINGS_1_TEAM_A_35_OVER_LINE: "Innings 1 Team A 35 Over Line",
  INNINGS_1_TEAM_A_40_OVER_LINE: "Innings 1 Team A 40 Over Line",
  INNINGS_1_TEAM_A_45_OVER_LINE: "Innings 1 Team A 45 Over Line",
  INNINGS_1_TEAM_A_50_OVER_LINE: "Innings 1 Team A 50 Over Line",
  INNINGS_2_TEAM_A_5_OVER_LINE: "Innings 2 Team A 5 Over Line",
  INNINGS_2_TEAM_A_10_OVER_LINE: "Innings 2 Team A 10 Over Line",
  INNINGS_2_TEAM_A_15_OVER_LINE: "Innings 2 Team A 15 Over Line",
  INNINGS_2_TEAM_A_20_OVER_LINE: "Innings 2 Team A 20 Over Line",
  INNINGS_2_TEAM_A_25_OVER_LINE: "Innings 2 Team A 25 Over Line",
  INNINGS_2_TEAM_A_30_OVER_LINE: "Innings 2 Team A 30 Over Line",
  INNINGS_2_TEAM_A_35_OVER_LINE: "Innings 2 Team A 35 Over Line",
  INNINGS_2_TEAM_A_40_OVER_LINE: "Innings 2 Team A 40 Over Line",
  INNINGS_2_TEAM_A_45_OVER_LINE: "Innings 2 Team A 45 Over Line",
  INNINGS_2_TEAM_A_50_OVER_LINE: "Innings 2 Team A 50 Over Line",
  INNINGS_1_TEAM_B_5_OVER_LINE: "Innings 1 Team B 5 Over Line",
  INNINGS_1_TEAM_B_10_OVER_LINE: "Innings 1 Team B 10 Over Line",
  INNINGS_1_TEAM_B_15_OVER_LINE: "Innings 1 Team B 15 Over Line",
  INNINGS_1_TEAM_B_20_OVER_LINE: "Innings 1 Team B 20 Over Line",
  INNINGS_1_TEAM_B_25_OVER_LINE: "Innings 1 Team B 25 Over Line",
  INNINGS_1_TEAM_B_30_OVER_LINE: "Innings 1 Team B 30 Over Line",
  INNINGS_1_TEAM_B_35_OVER_LINE: "Innings 1 Team B 35 Over Line",
  INNINGS_1_TEAM_B_40_OVER_LINE: "Innings 1 Team B 40 Over Line",
  INNINGS_1_TEAM_B_45_OVER_LINE: "Innings 1 Team B 45 Over Line",
  INNINGS_1_TEAM_B_50_OVER_LINE: "Innings 1 Team B 50 Over Line",
  INNINGS_2_TEAM_B_5_OVER_LINE: "Innings 2 Team B 5 Over Line",
  INNINGS_2_TEAM_B_10_OVER_LINE: "Innings 2 Team B 10 Over Line",
  INNINGS_2_TEAM_B_15_OVER_LINE: "Innings 2 Team B 15 Over Line",
  INNINGS_2_TEAM_B_20_OVER_LINE: "Innings 2 Team B 20 Over Line",
  INNINGS_2_TEAM_B_25_OVER_LINE: "Innings 2 Team B 25 Over Line",
  INNINGS_2_TEAM_B_30_OVER_LINE: "Innings 2 Team B 30 Over Line",
  INNINGS_2_TEAM_B_35_OVER_LINE: "Innings 2 Team B 35 Over Line",
  INNINGS_2_TEAM_B_40_OVER_LINE: "Innings 2 Team B 40 Over Line",
  INNINGS_2_TEAM_B_45_OVER_LINE: "Innings 2 Team B 45 Over Line",
  INNINGS_2_TEAM_B_50_OVER_LINE: "Innings 2 Team B 50 Over Line",
};

export const MarketTypeIsImplementedForSeeding = new Set<MarketType>([
  MarketType.INNINGS_1_RUNS,
  MarketType.INNINGS_2_RUNS,
]);

export class BetfairPrice {
  backPrice: number;
  layPrice: number;
  backSize: number;
  laySize: number;
  midPoint: number;
}

export interface MarketInfo {
  marketId: string;
  runners: RunnerCatalog[];
}

export interface RunnerCatalog {
  selectionId: number;
  runnerName: string;
  handicap: number;
  sortPriority: number;
  metadata: Map<string, string>;
}

export class MarketSubscription {
  latestPrices: Map<MarketType, Map<string, BetfairPrice>>;
}

export class BetfairPriceUpdateMessage {
  public eventId: string;
  public subscription: MarketSubscription;

  public static deserialize(msg: any): BetfairPriceUpdateMessage {
    return {
      eventId: msg.eventId,
      subscription: BetfairPriceUpdateMessage.deserializeMarketSubscription(
        msg.subscription
      ),
    };
  }

  private static deserializeMarketSubscription(msg: any): MarketSubscription {
    return {
      latestPrices: BetfairPriceUpdateMessage.deserializeLatestPrices(
        msg.latestPrices
      ),
    };
  }

  private static deserializeLatestPrices(
    msg: any
  ): Map<MarketType, Map<string, BetfairPrice>> {
    const map: Map<MarketType, Map<string, BetfairPrice>> = new Map();
    for (const [key, value] of Object.entries(msg)) {
      map.set(
        MarketType[key],
        BetfairPriceUpdateMessage.deserializePriceMap(value)
      );
    }
    return map;
  }

  private static deserializePriceMap(msg: any): Map<string, BetfairPrice> {
    const map: Map<string, BetfairPrice> = new Map();
    for (const [key, value] of Object.entries(msg)) {
      map.set(key, value as BetfairPrice);
    }
    return map;
  }
}
